import React from "react";
import { IDocumentDetails } from "../../../@types/models";
import ArchiveDetail from "../archiveDetail/archiveDetail";
import ArchiveHome from "../archiveHome/archiveHome";

export const getArchiveHome = (): React.JSX.Element => {
    return (
        <ArchiveHome />
    );
};
export const getDocumentDetailComp = (documentInfo: IDocumentDetails): React.JSX.Element => {
    return (
        <ArchiveDetail
            AccessCodeDesc={documentInfo.AccessCodeDesc}
            CaseDescription={documentInfo.CaseDescription}
            ArchiveCode={documentInfo.ArchiveCode}
            CaseNumber={documentInfo.CaseNumber}
            CategoryCode={documentInfo.DocumentCategory ? documentInfo.DocumentCategory : documentInfo.CategoryCode}
            DocumentDetailsLink={documentInfo.DocumentDetailsLink}
            DocumentTitle={documentInfo.DocumentTitle}
            DocumentNumber={documentInfo.Documentnumber ? documentInfo.Documentnumber : documentInfo.DocumentNumber}
            OrgUnitName={documentInfo.OrgUnitName}
            Paragraph={documentInfo.Paragraph}
            ResponsibleName={documentInfo.ResponsibleName}
            FileStatus={documentInfo.FileStatus}
            DocumentRecno={documentInfo.DocumentRecno}
        />
    );
};